import * as types from "../actionTypes";
import initialState from "../../../reducers/initialState";
import { combineReducers } from "redux";

const addressesReducer = (state = initialState.addresses, action) => {
  switch (action.type) {
    case types.LOAD_ADDRESS_LIST_STARTED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: true, loaded: false };
      return result;
    }

    case types.LOAD_ADDRESS_LIST_SUCCEEDED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: false, loaded: true, ids: action.result };
      return result;
    }

    case types.LOAD_ADDRESS_LIST_FAILED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...result[key], loading: false, loaded: false };
      return result;
    }

    case types.UPDATE_ADDRESS_SUCCEEDED: {
      const { partnerId, ids } = action;
      let result = { ...state };
      result[partnerId] = { ...result[partnerId], loading: false, loaded: true, ids: ids };
      return result;
    }
    default:
      return state;
  }
};

const addressFromOCRReducer = (state = null, action) => {
  switch (action.type) {
    case types.LOAD_CLIENT_BY_CARD_SUCCEEDED: {
      const { ocrResponse, partnerId } = action.payload;
      if (ocrResponse && ocrResponse.address) {
        const key = partnerId ?? ocrResponse.generalData.uniqueId;
        if (!key || key.toString().trim() === '') return null;
        return {[key]: { ...ocrResponse.address }}
      }
      return null;
    }

    case types.CONSUME_ADDRESS_FROM_OCR: {
      return null;
    }

    default:
      return state;
  }
};

export default combineReducers({
  list: addressesReducer,
  addressFromOCR: addressFromOCRReducer
});
